import { Typography } from '@mui/material';

export const Text = ({ id, value, updateValue, path, text, type, visible }) => {
  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <Typography variant={type ?? 'h1'} gutterBottom>{text}</Typography>
    </div>
  );
};
